import React, { useState } from "react"
import { PauseCircle } from "react-bootstrap-icons"
import { PlayCircle, PlusCircle } from "../shared/MediaIcons"
import { useAppDispatch, useAppSelector } from "../../stores/hooks"
import {
  prependAndPlay,
  playOrPause,
} from "../../stores/mediaPlayerSlice"
import { openSongActions } from "../../stores/songActionsSlice"

const ICON_SIZE = "1.6rem"
const MARGIN_SPACING = "0.4rem 0.5rem 0.4rem 0"

export const SingleTrackItem = ({ song, index }) => {
  const [showLyrics, setShowLyrics] = useState(false)
  const dispatch = useAppDispatch()
  const currentMediaItem = useAppSelector(
    (state) => state.mediaPlayer.value.currentMediaItem,
  )
  const playerState = useAppSelector(
    (state) => state.mediaPlayer.value.playerState,
  )
  const isCurrentlyPlaying =
    playerState === "playing" && currentMediaItem?.postId === song.id
  const isCurrentlyQueued =
    playerState === "paused" && currentMediaItem?.postId === song.id

  const onPlayClick = (e) => {
    dispatch(prependAndPlay(mappedSong()))
  }
  const onPlayOrPauseClick = (e) => {
    dispatch(playOrPause())
  }

  const onAddClick = (e) => {
    dispatch(openSongActions(mappedSong()[0]))
  }

  const mappedSong = () => {
    return [song].map((song) => ({
      ...song,
    }))
  }

  return (
    <li className="">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {isCurrentlyPlaying ? (
            <PauseCircle
              className={`cursor-pointer`}
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={onPlayOrPauseClick}
            />
          ) : (
            <PlayCircle
              className={`mt-1 mr-1`}
              style={{
                minWidth: ICON_SIZE,
                width: ICON_SIZE,
                height: ICON_SIZE,
                margin: MARGIN_SPACING,
              }}
              onClick={isCurrentlyQueued ? onPlayOrPauseClick : onPlayClick}
              disabled={!song.streaming_url}
            />
          )}
          <PlusCircle
            className={`mt-1 mr-1`}
            style={{
              minWidth: ICON_SIZE,
              width: ICON_SIZE,
              height: ICON_SIZE,
              margin: MARGIN_SPACING,
            }}
            onClick={onAddClick}
            disabled={!song.streaming_url}
          />
          <span className="font-bold ml-2">
            {song.track_number || index + 1}.
          </span>
          &nbsp;
          <span
            className={`${
              song.streaming_url ? "text-gray-700" : "text-gray-400"
            }`}
          >
            {song.title}
          </span>
        </div>
        <div>
          {song.lyrics ? (
            <button
              className="text-xs text-gray-500 focus:outline-none"
              onClick={(e) => setShowLyrics(!showLyrics)}
            >
              {showLyrics ? "hide lyrics" : "show lyrics"}
            </button>
          ) : null}
        </div>
      </div>

      {showLyrics && (
        <div
          className="py-3 text-gray-800 italic"
          dangerouslySetInnerHTML={{
            __html: song.lyrics.replace(/\n/g, "<br/>"),
          }}
        ></div>
      )}
    </li>
  )
}
